{
  "name": "@saccadejs/plugin-preview",
  "version": "0.2.0",
  "description": "jsPsych plugin: start the saccade.js camera and show the face and eye-crop preview",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/jspsych/saccadejs.git",
    "directory": "packages/plugin-saccadejs-preview"
  },
  "keywords": [
    "jsPsych",
    "eye tracking",
    "webcam",
    "gaze",
    "saccade.js"
  ],
  "author": {
    "name": "Josh de Leeuw",
    "url": "https://github.com/jodeleeuw"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/saccadejs/issues"
  },
  "homepage": "https://github.com/jspsych/saccadejs/blob/main/packages/plugin-saccadejs-preview/README.md",
  "devDependencies": {
    "@jspsych/config": "^3.3.3",
    "@jspsych/test-utils": "^1.2.0",
    "@saccadejs/extension": "^0.2.0",
    "jspsych": "^8.0.0"
  },
  "peerDependencies": {
    "jspsych": ">=8.0.0",
    "@saccadejs/extension": ">=0.1.0"
  }
}
